import React, { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import PremiumTransferSection from "@/components/PremiumTransferSection";
import CarSection from "@/components/CarSection";
import ServicesSection from "@/components/ServicesSection";
import ReviewsSection from "@/components/ReviewsSection";
import TerritoryMap from "@/components/TerritoryMap";
import BookingSection from "@/components/BookingSection";
import ContactSection from "@/components/ContactSection";
import FriendsSection from "@/components/FriendsSection";
import Footer from "@/components/Footer";
import { fetchServices, fetchPois, fetchAvailability } from "@/api";
import { useI18n } from "@/i18n";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

// IDs of JSON-LD scripts injected by city landing pages — must be cleaned when
// the user navigates back to the homepage to prevent stale schema markup.
const CITY_LD_IDS = [
  "ld-service-sts",
  "ld-faq-sts",
  "ld-breadcrumb-sts",
  ...["olbia", "palau", "cannigione", "baja-sardinia", "bonifacio"].flatMap((s) => [
    `ld-${s}-service`,
    `ld-${s}-faq`,
    `ld-${s}-breadcrumb`,
  ]),
];

const HOME_META = {
  it: {
    title: "Gallura Drive · Autista privato NCC in Costa Smeralda & Olbia",
    description:
      "Servizio di autista privato (NCC) in Gallura e Costa Smeralda. Transfer aeroporto Olbia, Santa Teresa Gallura, Palau, Cannigione, Baja Sardinia, Porto Cervo, Bonifacio. Tour privati con Chrysler 300C blu. Prenota online, paga in auto.",
  },
  en: {
    title: "Gallura Drive · Private Chauffeur NCC in Costa Smeralda & Olbia",
    description:
      "Private chauffeur (NCC) service in Gallura and Costa Smeralda. Airport transfers from Olbia to Porto Cervo, Santa Teresa Gallura, Palau, Cannigione, Baja Sardinia, Bonifacio. Private tours with blue Chrysler 300C. Book online, pay in the car.",
  },
};

const OG_IMAGE =
  "https://customer-assets.emergentagent.com/job_gallura-auto-rental/artifacts/vfttlow5_1782508931419.jpg.jpg";

export default function LandingPage() {
  const { lang } = useI18n();
  const [services, setServices] = useState([]);
  const [pois, setPois] = useState([]);
  const [booked, setBooked] = useState({});
  const [selectedServiceId, setSelectedServiceId] = useState("");

  const meta = HOME_META[lang] || HOME_META.it;
  useDocumentMeta({
    title: meta.title,
    description: meta.description,
    canonical: "https://galluradrive.it/",
    ogImage: OG_IMAGE,
    clearLdIds: CITY_LD_IDS,
  });

  useEffect(() => {
    fetchServices().then(setServices).catch(() => {});
    fetchPois().then(setPois).catch(() => {});
    fetchAvailability().then(setBooked).catch(() => {});
    // fetch* are stable module imports; safe to omit from deps.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectService = (id) => {
    setSelectedServiceId(id);
    setTimeout(() => {
      document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
    }, 80);
  };

  return (
    <div data-testid="landing-page">
      <Navbar />
      <Hero />
      <PremiumTransferSection />
      <CarSection />
      <ServicesSection services={services} onSelectService={handleSelectService} />
      <ReviewsSection />
      <TerritoryMap pois={pois} />
      <BookingSection
        services={services}
        booked={booked}
        selectedServiceId={selectedServiceId}
        onSelectService={setSelectedServiceId}
      />
      <ContactSection />
      <FriendsSection />
      <Footer />
    </div>
  );
}
